import curry from "ramda/es/curry";
export default curry((formName, actionName)=>`${formName}/${actionName}`);
